var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusAtRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6206 15.5937C11.4063 15.8081 11.1157 15.9285 10.8126 15.9286H6.04457C5.74149 15.9285 5.45085 15.8081 5.23657 15.5937L1.33486 11.692C1.12051 11.4777 1.00006 11.1871 1 10.884V6.11601C1.00006 5.81293 1.12051 5.52229 1.33486 5.30801L5.23657 1.4063C5.45085 1.19196 5.74149 1.07151 6.04457 1.07144H10.8126C11.1157 1.07151 11.4063 1.19196 11.6206 1.4063L15.5223 5.30801C15.7366 5.52229 15.8571 5.81293 15.8571 6.11601V10.884C15.8571 11.1871 15.7366 11.4777 15.5223 11.692L11.6206 15.5937Z",
    stroke: "#E81333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42859 5.07144V8.78573",
    stroke: "#E81333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42854 11.9286C8.35276 11.9286 8.28009 11.8985 8.22651 11.8449C8.17292 11.7913 8.14282 11.7186 8.14282 11.6429C8.14282 11.5671 8.17292 11.4944 8.22651 11.4408C8.28009 11.3872 8.35276 11.3571 8.42854 11.3571",
    stroke: "#E81333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42859 11.9286C8.50437 11.9286 8.57704 11.8985 8.63062 11.8449C8.6842 11.7913 8.7143 11.7186 8.7143 11.6429C8.7143 11.5671 8.6842 11.4944 8.63062 11.4408C8.57704 11.3872 8.50437 11.3571 8.42859 11.3571",
    stroke: "#E81333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusAtRisk);
export default __webpack_public_path__ + "static/media/status-at-risk.9ab4c63a4539056b6c0365dba9865a91.svg";
export { ForwardRef as ReactComponent };